const HIGHLIGHT_CLASSES = ["bg-primary/10", "outline-none"]

const CommandPalette = {
  mounted() {
    this.highlightedIndex = -1
    this.onWindowKeydown = event => {
      const paletteShortcut = (event.metaKey || event.ctrlKey) && event.key.toLowerCase() === "k"

      if (paletteShortcut) {
        event.preventDefault()
        this.highlightedIndex = -1
        this.pushEventTo(this.el, "open", {})
        return
      }

      if (this.el.dataset.state !== "open") return

      if (event.key === "ArrowDown" || event.key === "ArrowUp") {
        event.preventDefault()
        this.moveHighlight(event.key === "ArrowDown" ? 1 : -1)
      } else if (event.key === "Enter" && this.highlightedIndex >= 0) {
        event.preventDefault()
        this.rows()[this.highlightedIndex]?.click()
      }
    }

    window.addEventListener("keydown", this.onWindowKeydown)
  },

  updated() {
    const rows = this.rows()

    if (this.el.dataset.state !== "open" || this.highlightedIndex >= rows.length) {
      this.highlightedIndex = -1
    }

    this.renderHighlight(rows)
  },

  destroyed() {
    window.removeEventListener("keydown", this.onWindowKeydown)
  },

  rows() {
    return Array.from(this.el.querySelectorAll("[data-palette-row]"))
  },

  moveHighlight(step) {
    const rows = this.rows()
    if (rows.length === 0) return

    this.highlightedIndex =
      this.highlightedIndex < 0
        ? (step > 0 ? 0 : rows.length - 1)
        : (this.highlightedIndex + step + rows.length) % rows.length

    this.renderHighlight(rows)
    rows[this.highlightedIndex].scrollIntoView({block: "nearest"})
  },

  renderHighlight(rows = this.rows()) {
    rows.forEach((row, index) => {
      const highlighted = index === this.highlightedIndex
      row.classList.toggle(HIGHLIGHT_CLASSES[0], highlighted)
      row.classList.toggle(HIGHLIGHT_CLASSES[1], highlighted)
      row.setAttribute("aria-selected", highlighted.toString())
    })
  },
}

export default CommandPalette
